/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Authentication } from './Authentication';
import {
    AuthenticationFromJSON,
    AuthenticationFromJSONTyped,
    AuthenticationToJSON,
} from './Authentication';
import type { BillingAddress } from './BillingAddress';
import {
    BillingAddressFromJSON,
    BillingAddressFromJSONTyped,
    BillingAddressToJSON,
} from './BillingAddress';
import type { CustomerAccountInfo } from './CustomerAccountInfo';
import {
    CustomerAccountInfoFromJSON,
    CustomerAccountInfoFromJSONTyped,
    CustomerAccountInfoToJSON,
} from './CustomerAccountInfo';
import type { DeliveryAdditionalInfo } from './DeliveryAdditionalInfo';
import {
    DeliveryAdditionalInfoFromJSON,
    DeliveryAdditionalInfoFromJSONTyped,
    DeliveryAdditionalInfoToJSON,
} from './DeliveryAdditionalInfo';
import type { DeliveryAddress } from './DeliveryAddress';
import {
    DeliveryAddressFromJSON,
    DeliveryAddressFromJSONTyped,
    DeliveryAddressToJSON,
} from './DeliveryAddress';
import type { Holder } from './Holder';
import {
    HolderFromJSON,
    HolderFromJSONTyped,
    HolderToJSON,
} from './Holder';

/**
 * 
 * @export
 * @interface RiskAnalysis
 */
export interface RiskAnalysis {
    /**
     * 
     * @type {BillingAddress}
     * @memberof RiskAnalysis
     */
    billingAddress?: BillingAddress;
    /**
     * 
     * @type {Holder}
     * @memberof RiskAnalysis
     */
    holder?: Holder;
    /**
     * 
     * @type {DeliveryAddress}
     * @memberof RiskAnalysis
     */
    deliveryAddress?: DeliveryAddress;
    /**
     * 
     * @type {DeliveryAdditionalInfo}
     * @memberof RiskAnalysis
     */
    deliveryAdditionalInfo?: DeliveryAdditionalInfo;
    /**
     * 
     * @type {CustomerAccountInfo}
     * @memberof RiskAnalysis
     */
    customerAccountInfo?: CustomerAccountInfo;
    /**
     * 
     * @type {Authentication}
     * @memberof RiskAnalysis
     */
    authentication?: Authentication;
}

/**
 * Check if a given object implements the RiskAnalysis interface.
 */
export function instanceOfRiskAnalysis(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RiskAnalysisFromJSON(json: any): RiskAnalysis {
    return RiskAnalysisFromJSONTyped(json, false);
}

export function RiskAnalysisFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskAnalysis {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'billingAddress': !exists(json, 'billingAddress') ? undefined : BillingAddressFromJSON(json['billingAddress']),
        'holder': !exists(json, 'holder') ? undefined : HolderFromJSON(json['holder']),
        'deliveryAddress': !exists(json, 'deliveryAddress') ? undefined : DeliveryAddressFromJSON(json['deliveryAddress']),
        'deliveryAdditionalInfo': !exists(json, 'deliveryAdditionalInfo') ? undefined : DeliveryAdditionalInfoFromJSON(json['deliveryAdditionalInfo']),
        'customerAccountInfo': !exists(json, 'customerAccountInfo') ? undefined : CustomerAccountInfoFromJSON(json['customerAccountInfo']),
        'authentication': !exists(json, 'authentication') ? undefined : AuthenticationFromJSON(json['authentication']),
    };
}

export function RiskAnalysisToJSON(value?: RiskAnalysis | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'billingAddress': BillingAddressToJSON(value.billingAddress),
        'holder': HolderToJSON(value.holder),
        'deliveryAddress': DeliveryAddressToJSON(value.deliveryAddress),
        'deliveryAdditionalInfo': DeliveryAdditionalInfoToJSON(value.deliveryAdditionalInfo),
        'customerAccountInfo': CustomerAccountInfoToJSON(value.customerAccountInfo),
        'authentication': AuthenticationToJSON(value.authentication),
    };
}

